<template>
  <div class="dropdown" :class="{ 'is-active': active }">
    <div v-if="hasBackdrop && active" class="dropdown-backdrop"></div>
    <div class="dropdown-trigger" @click.stop="active = true">
      <slot name="trigger"></slot>
    </div>
    <div class="dropdown-menu">
      <div class="dropdown-content">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Dropdown',
  props: {
    hasBackdrop: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      active: false
    };
  },
  mounted() {
    document.addEventListener('click', () => {
      this.active = false;
    });

    document.addEventListener('keydown', event => {
      const e = event || window.event;
      if (e.keyCode === 27) {
        this.active = false;
      }
    });
  }
};
</script>

<style lang="scss">
.dropdown-content {
  .button:not(:last-child) {
    margin-bottom: 15px;
  }
  .button {
    margin-left: 0 !important;
  }
}

.dropdown-menu {
  z-index: 31;
}

.dropdown-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 19;
  background-color: $modal-background-background-color;
}
</style>
